
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/reusableComponents/dropdown',['Vue'],function(Vue){
        return {
            name:'dropDown',
            template:template,
            props: ['handleOptionClick', 'options', 'description', 'className', 'trailing', 'handleTrailingOptionClick']
        }
    })
})('<div :class="[\'dropdown\', className]"> <a class="dropdown-toggle" data-toggle="dropdown" href="#"><slot name="icon"></slot></a> <ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"> <li v-if="description" class="dropdownDescription">{{description}}</li> <li v-for="(option, index) in options" :key="index+option.text"> <a :href="option.disable ? null : \'#\'" :class="{disabled: option.disable}" @click="handleOptionClick($event, option)">{{option.text}} </a> </li> <li v-if="trailing"><a href="#" @click="handleTrailingOptionClick($event)">{{trailing}}</a></li> </ul> </div>');
